import React from 'react';

import FormAdd from '../../../../gd-form/form/form-add/form-add'
import FormManager from '../../../../gd-form/common/form-manager'
import {Copy_Manager} from "../../model/manager"
import ProjectForm_Name from "./name/name"
import {CopyTemplate_Manager} from "../../model/copy-template-manager"
import {ButtonType} from "../../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import Modal_Submit from "../../../components/submit/submit"

type Props = {
    manager : Copy_Manager
}

export default function ModalCopy_Template(props: Props) {

    const manager = props.manager as CopyTemplate_Manager
    
    const onSubmit = (result: any) => {
        manager.commitCopy(result)
    }

    const initFormData = {
        name: manager.projectToCopy.name
    }

    const formStructure = {
        isFormChanged   : true,
        fields          : {
            name    : {
                type        : 'select',
                isRequired  : true,
            }
        },
        onSubmit        : onSubmit
    }

    const form: FormManager = new FormManager(formStructure,initFormData)

    return (
        <div className="flex-column-top-stretch flex-1 min-h-0">
            <FormAdd className  = "flex-row-left-top flex-1"
                     style      = {{height: 'calc(100% - 50px - 90px)'}}
                     form       = {form}
                     showSubmit = {false}>
                <div className="tbl">
                    <ProjectForm_Name form={form}/>
                </div>
            </FormAdd>

            <Modal_Submit type      = {ButtonType.PRIMARY}
                          label     = "Copy"
                          onSubmit  = {()=>{form.onSubmitClick()}}/>
        </div>
    )
}